
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 261.76 226.69"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M161.096.001l-30.224 52.35L100.647.002H-.005L130.872 226.69 261.749 0z","fill":"#41b883"}}),_c('path',{attrs:{"d":"M161.096.001l-30.224 52.35L100.647.002H52.346l78.526 136.01L209.398.001z","fill":"#34495e"}})])
          )
        }
      }
    